import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { IconButton, Menu, MenuItem } from '@mui/material';
import Icon from '@mdi/react';
import { mdiDotsHorizontal } from '@mdi/js';
import DeleteCardConfirmPopover from '../common/delete_card_confirm_popover';
import PopupTitle from '../common/popup_title';

const PlannerWeekActionsPopupMenu = ({
  onAddWeekMealsToMealsBasket,
  onCopyPreviousWeekMeals,
  onDeleteAllMeals,
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = !!anchorEl;
  const [deletePopupAnchorEl, setDeletePopupAnchorEl] = useState(null);

  const handleClick = (event) => {
    setDeletePopupAnchorEl(null);
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setDeletePopupAnchorEl(null);
    setAnchorEl(null);
  };
  const handleDeleteAllMeals = () => {
    setDeletePopupAnchorEl(null);
    handleClose();
    onDeleteAllMeals();
  };
  const handleCopyPreviousWeekMeals = () => {
    setDeletePopupAnchorEl(null);
    handleClose();
    onCopyPreviousWeekMeals();
  };
  const handleAddToMealBasket = () => {
    handleClose();
    onAddWeekMealsToMealsBasket();
  };

  return (
    <>
      <Menu
        id="long-menu"
        MenuListProps={{
          'aria-labelledby': 'long-button',
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}>
        <PopupTitle
          titleText="Choose option"
          closeButtonEnabled
          onClickClose={handleClose}
        />
        <MenuItem onClick={handleAddToMealBasket}>
          Add all meals to shopping list
        </MenuItem>
        <MenuItem onClick={handleCopyPreviousWeekMeals}>
          Copy meals from last week
        </MenuItem>
        <MenuItem onClick={(ev) => setDeletePopupAnchorEl(ev.target)}>
          Delete all meals for the week
        </MenuItem>
      </Menu>
      <IconButton
        aria-label="more"
        id="long-button"
        aria-controls="long-menu"
        aria-expanded={open && 'true'}
        aria-haspopup="true"
        size="small"
        className="actionsPopupMenu"
        onClick={handleClick}>
        <Icon path={mdiDotsHorizontal} />
      </IconButton>
      <DeleteCardConfirmPopover
        anchorEl={deletePopupAnchorEl}
        visible={!!deletePopupAnchorEl}
        onDismiss={() => setDeletePopupAnchorEl(null)}
        message="All the meals for this week will be deleted permanently. Are you sure?"
        onConfirmDelete={handleDeleteAllMeals}
        height={160}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        title="Delete all meals"
      />
    </>
  );
};

PlannerWeekActionsPopupMenu.propTypes = {
  onAddWeekMealsToMealsBasket: PropTypes.func.isRequired,
  onCopyPreviousWeekMeals: PropTypes.func.isRequired,
  onDeleteAllMeals: PropTypes.func.isRequired,
};

export default PlannerWeekActionsPopupMenu;
